'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachmentsErrorForThreadInProps = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getFileUploadsErrors = require('./getFileUploadsErrors');

var _identifierForThread = require('../operators/identifierForThread');

var _threadFromProps = require('../../threads/selectors/threadFromProps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var attachmentsErrorForThreadInProps = exports.attachmentsErrorForThreadInProps = (0, _reselect.createSelector)([_getFileUploadsErrors.getFileUploadsErrors, _threadFromProps.threadFromProps], function (fileUploadsErrors, thread) {
  var threadIdentifier = (0, _identifierForThread.identifierForThread)(thread);

  return (0, _get2.default)(threadIdentifier, fileUploadsErrors) || null;
});


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/selectors/attachmentsErrorForThreadInProps.js
// module id = 652
// module chunks = 2 3